import { FC } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/Dialog/Dialog'
import { AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { useTranslation } from 'react-i18next'
import { EditPromotionForm } from '@/features/Promotion/EditPromotionForm'

type EditPromotionModalProps = {
  dialogProps: AlertDialogProps
  currentPromotionId: number
  onCloseModal: () => void
}

export const EditPromotionModal: FC<EditPromotionModalProps> = props => {
  const { dialogProps, currentPromotionId, onCloseModal } = props
  const { t } = useTranslation(['promotion'])

  return (
    <Dialog {...dialogProps}>
      <DialogContent className={'overflow-y-auto max-h-[95vh]'}>
        <DialogHeader>
          <DialogTitle>{t('promotion:edit_promotion_modal_title')}</DialogTitle>
          <EditPromotionForm currentPromotionId={currentPromotionId} onCloseModal={onCloseModal} />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
